<template lang="html">
  <v-container>
    <v-row>
      <v-col class="col-12 my-2 mb-md-12">
        <v-card>
          <v-carousel v-model="carouselId" hide-delimiters cycle interval="6000" height="15rem">
            <v-carousel-item v-for="(banner,i) in banners" :key="i">
              <v-img :src="banner.img"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-col>
      <v-col class="col-12">
        <div class="text-h5">导航</div>
      </v-col>
      <v-col class="col-sm-6 col-lg-4 col-12" style="display: table-cell;">
        <v-card  @click="openLink('https://blog.fab.moe/')" v-ripple>
          <v-card-title>个人博客</v-card-title>
        </v-card>
      </v-col>
      <v-col class="col-sm-6 col-lg-4 col-12" style="display: table-cell;">
        <v-card  @click="openLink('https://github.com/skyTNT')" v-ripple>
          <v-card-title>Github</v-card-title>
        </v-card>
      </v-col>
      <v-col class="col-sm-6 col-lg-4 col-12" style="display: table-cell;">
        <v-card  @click="openLink('https://lyric.fab.moe/')" v-ripple>
          <v-card-title>ai作词</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EffectView from '@/components/EffectView'

export default {
  name: 'MainPage',
  components: {
    EffectView
  },
  methods:{
    openLink(url){
      window.open(url);//不能直接写@click里
    }
  },
  data() {
    return {
      carouselId: 0,
      banners: [//横幅
        {
          img: "/static/img/bg/1.jpg",
          word: ""
        },
        {
          img: "/static/img/bg/2.png",
          word: ""
        },
        {
          img: "/static/img/bg/3.png",
          word: ""
        },
        {
          img: "/static/img/bg/4.png",
          word: ""
        },
        {
          img: "/static/img/bg/5.png",
          word: ""
        }
      ]
    };
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue